(() => {
const $b01eafeb8c1fc40f$export$188d75d71883854a = {
    active: 'filter__element--active',
    filterAlwaysOn: 'filter--always-on',
    filterSelectFirst: 'filter--select-first'
};
const $b01eafeb8c1fc40f$export$e1252723db1c541 = {
    activeFilterElement: `.${$b01eafeb8c1fc40f$export$188d75d71883854a.active}`,
    filterButton: '.filter__element',
    filterNavigation: '.filter',
    filterSelect: 'select',
    tiles: 'div[data-cat], li[data-cat], a[data-cat]'
};
const $b01eafeb8c1fc40f$export$3087c827deadc62e = 'mcflyFilterChange';


const $146cd4dc0f3630a4$var$hideElement = (el)=>el.hidden = true;
const $146cd4dc0f3630a4$var$showElement = (el)=>el.hidden = false;
const $146cd4dc0f3630a4$export$6002050ff15b8b96 = (e)=>{
    const filterNavigation = e.target.closest((0, $b01eafeb8c1fc40f$export$e1252723db1c541).filterNavigation);
    // Add a hash to the URL to allow direct linking to a specific category if a real user interaction is detected.
    if (e.isTrusted) window.location.hash = e.target.value;
    // Dispatch the filter change event
    filterNavigation.dispatchEvent(new CustomEvent((0, $b01eafeb8c1fc40f$export$3087c827deadc62e), {
        detail: {
            filterValue: e.target.value
        },
        bubbles: true
    }));
};
const $146cd4dc0f3630a4$export$e6cb70c33c958e7d = (e)=>{
    const target = e.currentTarget;
    const filterNavigation = target.closest((0, $b01eafeb8c1fc40f$export$e1252723db1c541).filterNavigation);
    const selectedFilter = filterNavigation.querySelector((0, $b01eafeb8c1fc40f$export$e1252723db1c541).activeFilterElement);
    // If the "always on" property is enabled, it should prevent the currently active filter from being disabled when the user clicks on it.
    if (filterNavigation.classList.contains((0, $b01eafeb8c1fc40f$export$188d75d71883854a).filterAlwaysOn) && target === selectedFilter) return;
    if (selectedFilter && selectedFilter === target) // Clicked the item that was already selected
    target.classList.remove((0, $b01eafeb8c1fc40f$export$188d75d71883854a).active);
    else {
        // Clicked another item than the selected one
        selectedFilter?.classList.remove((0, $b01eafeb8c1fc40f$export$188d75d71883854a).active);
        target.classList.add((0, $b01eafeb8c1fc40f$export$188d75d71883854a).active);
    }
    const filterValue = filterNavigation.querySelector((0, $b01eafeb8c1fc40f$export$e1252723db1c541).activeFilterElement)?.getAttribute('data-cat') || '';
    // Add a hash to the URL to allow direct linking to a specific category if a real user interaction is detected.
    if (e.isTrusted) window.location.hash = filterValue;
    // Dispatch the filter change event
    filterNavigation.dispatchEvent(new CustomEvent((0, $b01eafeb8c1fc40f$export$3087c827deadc62e), {
        detail: {
            filterValue: filterValue
        },
        bubbles: true
    }));
};
const $146cd4dc0f3630a4$export$466e4ac576e3445 = (tilesContainer, filterValue)=>{
    if (!tilesContainer) return;
    tilesContainer.querySelectorAll((0, $b01eafeb8c1fc40f$export$e1252723db1c541).tiles).forEach((tile)=>{
        // Show every tile
        $146cd4dc0f3630a4$var$showElement(tile);
        if (filterValue) {
            // Hide tile if it its categories don't contain the target category
            const tileCategories = tile.getAttribute('data-cat').split(' ');
            !tileCategories.includes(filterValue) && $146cd4dc0f3630a4$var$hideElement(tile);
        }
    });
};



const $fa31c1a7d4aef9ba$var$initFilterSelect = (nav, urlHashValue)=>{
    const select = nav.querySelector((0, $b01eafeb8c1fc40f$export$e1252723db1c541).filterSelect);
    if (!select) return;
    if (urlHashValue) {
        const targetFilterElement = nav.querySelector(`${(0, $b01eafeb8c1fc40f$export$e1252723db1c541).filterSelect} option[value="${urlHashValue}"]`);
        if (targetFilterElement) select.value = urlHashValue;
    }
    // Dispatch a change event to show the correct tiles on page load
    select.dispatchEvent(new Event('change'));
};
const $fa31c1a7d4aef9ba$var$initFilterButtons = (nav, urlHashValue)=>{
    const filterButtons = nav.querySelectorAll((0, $b01eafeb8c1fc40f$export$e1252723db1c541).filterButton);
    if (!filterButtons.length) return;
    const targetFilterElement = nav.querySelector(`${(0, $b01eafeb8c1fc40f$export$e1252723db1c541).filterButton}[data-cat="${urlHashValue}"]`);
    if (urlHashValue && targetFilterElement) !targetFilterElement.classList.contains((0, $b01eafeb8c1fc40f$export$188d75d71883854a).active) && targetFilterElement.click();
    else // If one filter element is always on or the first filter element should be preselected, the first filter element is clicked.
    if ([
        (0, $b01eafeb8c1fc40f$export$188d75d71883854a).filterSelectFirst,
        (0, $b01eafeb8c1fc40f$export$188d75d71883854a).filterAlwaysOn
    ].some((className)=>nav.classList.contains(className))) nav.querySelector((0, $b01eafeb8c1fc40f$export$e1252723db1c541).filterButton)?.click();
};
document.querySelectorAll((0, $b01eafeb8c1fc40f$export$e1252723db1c541).filterNavigation).forEach((nav)=>{
    /**
	 * Add the event listeners
	 */ // Add the filter change event listener to the filter navigation element
    nav.addEventListener((0, $b01eafeb8c1fc40f$export$3087c827deadc62e), (e)=>{
        (0, $146cd4dc0f3630a4$export$466e4ac576e3445)(nav.nextElementSibling, e.detail.filterValue);
    });
    // Mobile Control: Add the change event listener to the select element
    nav.querySelector((0, $b01eafeb8c1fc40f$export$e1252723db1c541).filterSelect)?.addEventListener('change', (0, $146cd4dc0f3630a4$export$6002050ff15b8b96));
    // Desktop Control: Add the click event listener to every filter button
    nav.querySelectorAll((0, $b01eafeb8c1fc40f$export$e1252723db1c541).filterButton).forEach((filterEl)=>filterEl.addEventListener('click', (0, $146cd4dc0f3630a4$export$e6cb70c33c958e7d)));
    /**
	 * Initialize the filter control elements
	 */ // Extract the hash value from the URL
    // ? Is there a better way instead of using the hash?
    const hashValue = window.location.hash.replace('#', '');
    $fa31c1a7d4aef9ba$var$initFilterSelect(nav, hashValue);
    $fa31c1a7d4aef9ba$var$initFilterButtons(nav, hashValue);
});

})();
//# sourceMappingURL=filter.min.js.map
